/**
 * Django CSRF token, read from the `csrftoken` cookie. Every allauth headless
 * response sets/refreshes this cookie (the browser client calls Django's
 * get_token() per request), so calling the session endpoint at boot is enough
 * to guarantee it exists before any mutation.
 */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|; )csrftoken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export default getCsrfToken;
